import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import { validation, formfields } from "kea-react";
import { observeResource } from "kea-resource";
import { createSelectorRx, truncateDate } from "keautils";
import { componentToRx } from "app/logic/rx";
import * as history from "app/main/history";
import { PaqueteRADList } from "./paquetes/list";
import { SelectorHora } from "app/features/selectores/index";
import { SelectorHoraBitacora } from "app/features/selectores/index";
import { PropsToRx } from "react-rxk";

type Entity = models.BitacoraRAD;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
    permisos: models.Rol;
}


class BitacoraRADFormNoRx extends React.PureComponent<Props> {
    errors = () => this.props.nuevo ? validation.getErrors({

        IdSucursal: this.props.permisos.BitacoraRAD.VerTodasSucursales ? validation.required : undefined,
        IdDireccionCliente: validation.required,
        FechaSolicitud: validation.required,
        TipoRecoleccion: validation.required,
        CanalEntrada: validation.required,
        QuienSolicita: validation.required,

        HorarioSugeridoDesde: (x) => 
        this.props.value.HorarioSugeridoDesde == null ? "Obligatorio" : 
        (
            this.props.value.HorarioSugeridoDesde > (this.props.value.HorarioSugeridoHasta != null ? this.props.value.HorarioSugeridoHasta:0) ?
            "Horario sugerido (desde) mayor a Horario sugerido (hasta)" : true
        ) ,

        HorarioSugeridoHasta: (x) => 
        this.props.value.HorarioSugeridoHasta == null ? "Obligatorio" : 
        (
            this.props.value.HorarioSugeridoHasta < (this.props.value.HorarioSugeridoDesde != null ? this.props.value.HorarioSugeridoDesde:0) ?
            "Horario sugerido (hasta) menor a Horario sugerido (desde)" : true
        ) ,

        Paquetes: (x) => (x == null || x.length == 0) ? "Obligatorio" : true,
        FechaProgramada: (x) =>
            this.props.value.FechaProgramada == null ? "Obligatorio" :
                (this.props.value.FechaSolicitud != null &&
                    truncateDate(this.props.value.FechaProgramada, "days").valueOf() < truncateDate(this.props.value.FechaSolicitud, "days").valueOf()
                ) ? "Fecha inválida" : true

    }, this.props.value) : {};

    getField = formfields(() => ({
        ... this.props,
        readonly: !this.props.nuevo
    }), this.errors);

    usuarios = (props: Props) => observeResource(resources.Usuario.query, {});

    idSucursal = (props: Props) => props.value.IdSucursal;
    usuariosFiltrados = createSelectorRx(this.usuarios, this.idSucursal, (usuarios, idSucursal) => usuarios.filter(x => x.IdSucursal == idSucursal));

    onTipoChange = (x: models.HorarioRad) => {
        this.props.onChange({
            ... this.props.value,
            TipoRecoleccion: x,
            FechaProgramada: x == models.HorarioRad.MismoDia ?
                (this.props.value.FechaSolicitud ? truncateDate(this.props.value.FechaSolicitud, "days") : undefined) : this.props.value.FechaProgramada
        });
    }

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;
        const Sucursal = getField(selectores.Sucursal);
        const DateTime = getField(kea.DateTime);
        const Cliente = getField(selectores.Cliente);
        const DireccionCliente = getField(selectores.DireccionClienteSelector);
        const ContenidoPaquete = getField(selectores.ContenidoPaquete);
        const Tipo = getField(selectores.BitacoraRADTipoSelector);
        const Text = getField(kea.Text);
        const Number = getField(kea.Number);
        const Paquetes = getField(PaqueteRADList);
        const Hora = getField(SelectorHoraBitacora);

        const QuienSolicita = getField(selectores.BitacoraRADQuienSolicita);
        const CanalEntrada = getField(selectores.BitacoraRADCanalEntrada);
        
        return (
            <div>
                <kea.Title titulo="Bitácora de Recolección a Domicilio" onRegresar={() => history.go("../")} >
                </kea.Title>
                {kea.autogrid(2, [
                    <DateTime field="FechaSolicitud" label="Fecha de solicitud" />,
                    <DateTime field="FechaProgramada" label="Fecha programada" readonly={this.props.value.TipoRecoleccion == models.HorarioRad.MismoDia} />,
                    <Tipo field="TipoRecoleccion" label="Tipo de recolección" onChange={this.onTipoChange} />,
                    <Sucursal field="IdSucursal" label="Sucursal que solicita" />,
                    <Sucursal field="IdSucursalRecoleccion" label="Sucursal de recolección" />,
                    <Text field="NombreQuienSolicita" label="Nombre de quien solicita" />,
                    <Text field="Telefono" />,
                    <Hora field="HorarioSugeridoDesde" label="Horario sugerido (desde)" />,
                    <Hora field="HorarioSugeridoHasta" label="Horario sugerido (hasta)" />,
                    
                ])}

                <hr />

                {kea.autogrid(6, [
                    <DireccionCliente field="IdDireccionCliente" label="Cliente" />,
                    <QuienSolicita field="QuienSolicita" label="Quien solicita" />,
                    <CanalEntrada field="CanalEntrada" label="Canal de entrada" />
                ])}
             
                <Paquetes field="Paquetes" />

                {kea.autogrid(6, [
                    <Text field="Observaciones" />
                ])}

                <div className="row">
                    <div className="col-md-12">
                        {
                            this.props.nuevo &&
                            <kea.GuardarButton onClick={onGuardar} disabled={validation.hasError(this.errors())} />
                        }
                    </div>
                </div>
            </div>);

    }
}

export const BitacoraRADForm = componentToRx(BitacoraRADFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/bitacoraRAD/edit/form.tsx